export const USER_STATUS = {
  INITIAL: "initial",
  INVITED: "invited",
  ACTIVE: "active",
  INACTIVE: "inactive"
}

export const USER_TRAINING_STATUS = {
  NONE: "none",
  IN_PROGRESS: "in_progress",
  OVERDUE: "overdue",
  COMPLETE: "complete"
}

export const USER_TRAINING_ASSESSMENT_STATUS = {
  NONE: "none",
  SCHEDULED: "scheduled",
  COMPETENT: "competent",
  NEEDS_TRAINING: "needs_training",
  TRAINER: "trainer",
  TRAINED: "trained",
  UNTRAINED: "untrained"
}

export const USER_TRAINING_ASSESSMENT_STATUS_LABELS = {
  [USER_TRAINING_ASSESSMENT_STATUS.NONE]: "None",
  [USER_TRAINING_ASSESSMENT_STATUS.SCHEDULED]: "Scheduled",
  [USER_TRAINING_ASSESSMENT_STATUS.COMPETENT]: "Competent",
  [USER_TRAINING_ASSESSMENT_STATUS.NEEDS_TRAINING]: "Needs training",
  [USER_TRAINING_ASSESSMENT_STATUS.TRAINER]: "Trainer",
  [USER_TRAINING_ASSESSMENT_STATUS.TRAINED]: "Trained",
  [USER_TRAINING_ASSESSMENT_STATUS.UNTRAINED]: "Untrained"
}

export const USER_ACCREDITATIONS_STATUS = {
  NONE: "none",
  AWAITING: "awaiting",
  WARNING: "warning",
  EXPIRED: "expired",
  COMPLIANT: "compliant"
}

export const USER_ACCREDITATIONS_STATUS_LABELS = {
  [USER_ACCREDITATIONS_STATUS.NONE]: "No accreditations",
  [USER_ACCREDITATIONS_STATUS.AWAITING]: "Awaiting upload",
  [USER_ACCREDITATIONS_STATUS.WARNING]: "Expiring soon",
  [USER_ACCREDITATIONS_STATUS.EXPIRED]: "Expired",
  [USER_ACCREDITATIONS_STATUS.COMPLIANT]: "Up to date"
}

export const NOTIFICATION_TYPE = {
  GENERAL: "general",
  PROCESS: "process",
  TASK: "task",
  KNOWLEDGE: "knowledge",
  POST: "post",
  JOB: "job",
  ACTION: "action",
  TRAINING: "training",
  ACCREDITATION: "accreditation",
  OBSERVATION: "observation",
  POST_COMMENT_MENTION: "post_comment_mention",
  WORKFLOW: "workflow"
}

export const NOTIFY_TYPE = {
  NONE: 0,
  NOTIFICATION: 1,
  EMAIL: 2
}

export const CRON_JOB_TYPE = {
  JOB_GENERATE_LOCATION_DAY_JOBS: 0,
  JOB_STATUS_NOTIFICATION: 1
}

export const PROCESS_TYPE = {
  PROCESS: "process",
  AUDIT: "audit",
  PUBLIC: "public",
  WORKFLOW: "workflow"
}

export const SEARCH_RESULT = {
  PROCESS: "Process",
  KNOWLEDGE: "Knowledge",
  POST: "Post",
  JOB: "Job",
  ACTION: "Action"
}

export const SEARCH_CATEGORY = {
  EVERYTHING: "everything",
  ACTIVE_JOBS: "activeJobs",
  KNOWLEDGE_BASE: "knowledgeBase",
  COMMS_HUB: "commsHub",
  ACTIONS: "actions"
}

export const SEARCH_CATEGORY_LABELS = {
  [SEARCH_CATEGORY.EVERYTHING]: "Everything",
  [SEARCH_CATEGORY.ACTIVE_JOBS]: "Active Jobs",
  [SEARCH_CATEGORY.KNOWLEDGE_BASE]: "Knowledge Base",
  [SEARCH_CATEGORY.COMMS_HUB]: "Comms Hub",
  [SEARCH_CATEGORY.ACTIONS]: "Actions"
}

export const PROCESS_REPEAT = {
  NEVER: 0,
  DAILY: 1,
  WEEKLY: 2,
  FORTNIGHTLY: 4,
  MONTHLY: 8,
  YEARLY: 9,
  ADHOC: 100,
  UNSCHEDULED: 200
}

export const PROCESS_REPEAT_RECURRING = [
  PROCESS_REPEAT.DAILY,
  PROCESS_REPEAT.WEEKLY,
  PROCESS_REPEAT.FORTNIGHTLY,
  PROCESS_REPEAT.MONTHLY,
  PROCESS_REPEAT.YEARLY
]

export const SCHEDULE_FILTER = {
  ONCE: { label: "One-off", type: PROCESS_REPEAT.NEVER },
  DAILY: { label: `Daily`, type: PROCESS_REPEAT.DAILY, frequency: 1 },
  WEEKLY: { label: "Weekly", type: PROCESS_REPEAT.WEEKLY, frequency: 1 },
  FORTNIGHTLY: {
    label: "Fortnightly",
    type: PROCESS_REPEAT.FORTNIGHTLY,
    frequency: 1
  },
  MONTHLY: { label: "Monthly", type: PROCESS_REPEAT.MONTHLY, frequency: 1 },
  YEARLY: { label: "Yearly", type: PROCESS_REPEAT.YEARLY, frequency: 1 },
  ADHOC: { label: "Adhoc", type: PROCESS_REPEAT.ADHOC }
}

export const SCHEDULE_FILTERS = Object.keys(SCHEDULE_FILTER).map((key) => ({
  key: key.toLowerCase(),
  ...SCHEDULE_FILTER[key]
}))

export const NON_RECURRING_SCHEDULE_FILTERS = Object.keys(SCHEDULE_FILTER)
  .filter(
    (key) =>
      ![PROCESS_REPEAT.NEVER, PROCESS_REPEAT.ADHOC, PROCESS_REPEAT.UNSCHEDULED].includes(SCHEDULE_FILTER[key].type)
  )
  .map((key) => ({
    key: key.toLowerCase(),
    ...SCHEDULE_FILTER[key]
  }))

export const PROCESS_SCHEDULE_AFTER = {
  DATE: "date",
  AT_OPEN: "at_open",
  AT_CLOSE: "at_close",
  HOURS_BEFORE_OPEN: "hours_before_open",
  HOURS_AFTER_OPEN: "hours_after_open",
  HOURS_BEFORE_CLOSE: "hours_before_close",
  HOURS_AFTER_CLOSE: "hours_after_close"
}

// m/h/d must be compatible with moment unit of time
export const PROCESS_SCHEDULE_DUE = {
  NONE: "none",
  MINUTES: "minutes",
  HOURS: "hours",
  DAYS: "days",
  AT_CLOSE: "at_close",
  AT_OPEN: "at_open",
  HOURS_BEFORE_OPEN: "hours_before_open",
  HOURS_AFTER_OPEN: "hours_after_open",
  HOURS_BEFORE_CLOSE: "hours_before_close",
  HOURS_AFTER_CLOSE: "hours_after_close"
}

export const PROCESS_SCHEDULE_UNTIL = {
  NONE: "none",
  COMPLETED: "completed",
  NEXT_INSTANCE: "next_instance",
  MINUTES: "minutes",
  HOURS: "hours",
  DAYS: "days"
}

export const PROCESS_SET = {
  ANY: "any",
  ACTIVE: "active",
  ACTIVE_RECURRING: "active-recurring",
  ACTIVE_ONEOFF: "active-oneoff",
  ACTIVE_ADHOC: "active-adhoc",
  ACTIVE_UNSCHEDULED: "active-unscheduled",
  INACTIVE: "inactive",
  INACTIVE_RECURRING: "inactive-recurring",
  INACTIVE_ONEOFF: "inactive-oneoff",
  INACTIVE_ADHOC: "inactive-adhoc",
  INACTIVE_UNSCHEDULED: "inactive-unscheduled"
}

export const PROCESS_STEP_RESPONSE_TYPE = {
  CHECKBOX: "checkbox",
  NUMBER: "number",
  TEXT: "text",
  LONG_TEXT: "long_text",
  DATE_TIME: "date_time",
  PHOTOS: "photos",
  MULTIPLE_CHOICE: "multiple_choice",
  PROCESS: "process",
  SIGNATURE: "signature",
  SECTION: "section",
  INSTRUCTION: "instruction",
  FILES: "files",
  SELECTION: "selection",
  TEMPERATURE_TIMER: "temperature_timer",
  TOUCHPOINT: "touchpoint",

  // deprecated for multiple_choice responseSets
  NUMBER_RATING_5: "number_rating_5",
  NUMBER_RATING_10: "number_rating_10"
}

export const PROCESS_STEP_NON_RESPONSE_TYPES = [
  PROCESS_STEP_RESPONSE_TYPE.SECTION,
  PROCESS_STEP_RESPONSE_TYPE.INSTRUCTION
]

export const PROCESS_STEP_RESPONSE_TYPES_WITH_SCORING = [
  PROCESS_STEP_RESPONSE_TYPE.MULTIPLE_CHOICE,
  PROCESS_STEP_RESPONSE_TYPE.NUMBER_RATING_5,
  PROCESS_STEP_RESPONSE_TYPE.NUMBER_RATING_10,
  PROCESS_STEP_RESPONSE_TYPE.PROCESS
]

export const PROCESS_STEP_RESPONSE_TYPES_USING_SELECTIONS = [
  PROCESS_STEP_RESPONSE_TYPE.SELECTION,
  PROCESS_STEP_RESPONSE_TYPE.TEMPERATURE_TIMER
]

export const PROCESS_STEP_LOGIC_RESPONSE_TYPES = [
  PROCESS_STEP_RESPONSE_TYPE.NUMBER,
  PROCESS_STEP_RESPONSE_TYPE.MULTIPLE_CHOICE,
  PROCESS_STEP_RESPONSE_TYPE.SELECTION
]

export const PROCESS_STEP_RESPONSE_VALUE_TYPES = {
  NUMBER: "number",
  TEXT: "text"
}

export const PROCESS_STEP_RESPONSE_OPTIONS = [
  {
    type: PROCESS_STEP_RESPONSE_TYPE.CHECKBOX,
    icon: "checkbox",
    label: "Checkbox",
    allowPublic: true
  },
  {
    type: PROCESS_STEP_RESPONSE_TYPE.PHOTOS,
    icon: "camera",
    label: "Photo submission"
  },
  {
    type: PROCESS_STEP_RESPONSE_TYPE.FILES,
    icon: "upload-file",
    label: "File submission"
  },
  { divider: "Inputs" },
  {
    type: PROCESS_STEP_RESPONSE_TYPE.TEXT,
    icon: "text",
    label: "Short text entry",
    allowPublic: true
  },
  {
    type: PROCESS_STEP_RESPONSE_TYPE.LONG_TEXT,
    icon: "long-text",
    label: "Long text entry",
    allowPublic: true
  },
  {
    type: PROCESS_STEP_RESPONSE_TYPE.NUMBER,
    icon: "number",
    label: "Number entry",
    adornments: ["logic", "bluetooth"],
    valueType: PROCESS_STEP_RESPONSE_VALUE_TYPES.NUMBER
  },
  {
    type: PROCESS_STEP_RESPONSE_TYPE.SELECTION,
    icon: "selection",
    label: "Selection",
    adornments: ["logic"],
    audit: true,
    valueType: PROCESS_STEP_RESPONSE_VALUE_TYPES.TEXT
  },
  {
    type: PROCESS_STEP_RESPONSE_TYPE.DATE_TIME,
    icon: "date",
    label: "Date & time entry",
    allowPublic: true
  },
  {
    type: PROCESS_STEP_RESPONSE_TYPE.TOUCHPOINT,
    icon: "nfc",
    label: "Scan NFC touchpoint",
    features: "process_step_nfc"
  },
  {
    type: PROCESS_STEP_RESPONSE_TYPE.SIGNATURE,
    icon: "signature",
    label: "Signature",
    audit: true,
    allowPublic: true
  },
  { divider: "Buttons" },
  {
    type: PROCESS_STEP_RESPONSE_TYPE.MULTIPLE_CHOICE,
    icon: "button",
    useResponseSet: true,
    appendToName: "buttons",
    canResponseFail: true,
    allowPublic: true,
    valueType: PROCESS_STEP_RESPONSE_VALUE_TYPES.TEXT
  },
  { divider: "More" },
  {
    type: PROCESS_STEP_RESPONSE_TYPE.SECTION,
    icon: "section",
    label: "Section",
    audit: true,
    allowPublic: true
  },
  {
    type: PROCESS_STEP_RESPONSE_TYPE.INSTRUCTION,
    icon: "instruction",
    label: "Instruction",
    audit: true,
    allowPublic: true
  },
  {
    type: PROCESS_STEP_RESPONSE_TYPE.PROCESS,
    icon: "steps",
    label: "Nest an existing process",
    audit: true,
    canNestedFail: true
  },
  {
    type: PROCESS_STEP_RESPONSE_TYPE.TEMPERATURE_TIMER,
    icon: "temperature-timer",
    label: "Temperature timer",
    features: ["food", "temperature_timer"]
  }
]

// Types that may be aggregated for purposes of reporting
export const PROCESS_STEP_AGGREGATABLE_RESPONSE_TYPES = [
  PROCESS_STEP_RESPONSE_TYPE.MULTIPLE_CHOICE,
  PROCESS_STEP_RESPONSE_TYPE.SELECTION,
  PROCESS_STEP_RESPONSE_TYPE.NUMBER_RATING_5,
  PROCESS_STEP_RESPONSE_TYPE.NUMBER_RATING_10
]

export const PROCESS_STEP_INPUT_TYPE = {
  MANUAL: "manual",
  DEVICE: "device",
  SENSOR: "sensor"
}

export const PROCESS_STEP_INPUT_TYPE_LABELS = {
  [PROCESS_STEP_INPUT_TYPE.MANUAL]: "Manual entry",
  [PROCESS_STEP_INPUT_TYPE.DEVICE]: "Bluetooth device",
  [PROCESS_STEP_INPUT_TYPE.SENSOR]: "Sensor"
}

export const RESPONSE_SET_DISPLAY_AS = {
  TEXT: "text",
  ICON: "icon"
}

export const JOBS_SET = {
  ALL_USERS: "all_users",
  SELF: "self",
  OTHERS: "others"
}

export const JOB_REPORT_DATE_TYPE = {
  COMPLETED: "completed",
  CREATED: "created"
}

export const JOB_STATUS = {
  TODO: "todo",
  IN_PROGRESS: "in_progress",
  AWAITING_SUBMISSION: "awaiting_submission",
  COMPLETED: "completed",
  SUBMITTED: "submitted",
  OVERDUE: "overdue"
}

export const JOB_STATUS_LABELS = {
  [JOB_STATUS.TODO]: "To Do",
  [JOB_STATUS.IN_PROGRESS]: "In progress",
  [JOB_STATUS.AWAITING_SUBMISSION]: "Awaiting submission",
  [JOB_STATUS.COMPLETED]: "Completed",
  [JOB_STATUS.SUBMITTED]: "Submitted",
  [JOB_STATUS.OVERDUE]: "Overdue"
}

export const UPLOAD_FILE_GROUP = {
  DOCUMENT: "document",
  IMAGE: "image",
  VIDEO: "video"
}

export const UPLOAD_FILE_GROUP_LABELS = {
  [UPLOAD_FILE_GROUP.DOCUMENT]: "Documents",
  [UPLOAD_FILE_GROUP.IMAGE]: "Images",
  [UPLOAD_FILE_GROUP.VIDEO]: "Videos"
}

export const KNOWLEDGE_CONTENT_TYPENAMES = {
  TEXT: "KnowledgeContentText",
  IMAGE: "KnowledgeContentImage",
  FILES: "KnowledgeContentFiles",
  NOTE: "KnowledgeContentNote",
  VIDEO: "KnowledgeContentVideo",
  MULTICHOICE: "KnowledgeContentMultichoice"
}

export const KNOWLEDGE_CONTENT_TIPTAP_TYPENAMES = {
  HEADING: "heading",
  TEXT: "paragraph",
  DETAILS: "details",
  DETAILS_SUMMARY: "detailsSummary",
  DETAILS_CONTENT: "detailsContent",
  IMAGE: "image",
  FILES: "customFile",
  NOTE: "note",
  VIDEO: "video",
  LINK: "link",
  BULLET_LIST: "bulletList", // tiptap extension name
  ORDERED_LIST: "orderedList", // tiptap extension name
  LIST_ITEM: "listItem", // tiptap extension name
  IMAGE_UPLOADER: "imageUploader",
  FILE_UPLOADER: "fileUploader",
  VIDEO_UPLOADER: "videoUploader",
  SELECTABLE_MEDIA: "selectableMedia",
  COMMANDS: "slashCommands",
  CUSTOM_LINK: "customLink",
  LOADING_SPINNER: "loadingSpinner",
  MENTION: "mention",
  TABLE: "table",
  TABLE_ROW: "tableRow",
  TABLE_CELL: "tableCell",
  TABLE_HEADER: "tableHeader",
  HORIZONTAL_RULE: "horizontalRule" // tiptap extension name for dividers
}

export const KNOWLEDGE_TYPE = {
  ARTICLE: "article",
  FILE: "file",
  TRAINING_MODULE: "training_module"
}

export const KNOWLEDGE_CONTENT_TYPENAME_LABELS = {
  [KNOWLEDGE_CONTENT_TYPENAMES.TEXT]: "Text content",
  [KNOWLEDGE_CONTENT_TYPENAMES.IMAGE]: "Image",
  [KNOWLEDGE_CONTENT_TYPENAMES.NOTE]: "Note (Information)",
  [KNOWLEDGE_CONTENT_TYPENAMES.NOTE_IMPORTANT]: "Note (Important)",
  [KNOWLEDGE_CONTENT_TYPENAMES.NOTE_DANGER]: "Note (Danger)",
  [KNOWLEDGE_CONTENT_TYPENAMES.FILES]: "File attachments",
  [KNOWLEDGE_CONTENT_TYPENAMES.VIDEO]: "Media",
  [KNOWLEDGE_CONTENT_TYPENAMES.MULTICHOICE]: "Multiple choice question"
}

export const KNOWLEDGE_CONTENT_NOTE_TYPE = {
  INFORMATION: "information",
  IMPORTANT: "important",
  DANGER: "danger"
}

export const ORGANISATION_INDUSTRIES = [
  "Accommodation",
  "Administrative and Support Services",
  "Agriculture, Forestry and Fishing",
  "Arts and Recreation Services",
  "Aviation and Marine",
  "Construction",
  "Education and Training",
  "Electricity, Gas, Water and Waste Services",
  "Financial and Insurance Services",
  "Healthcare",
  "Hospitality",
  "Information Media and Telecommunications",
  "Manufacturing",
  "Mining",
  "Professional, Scientific and Technical Services",
  "Public Administration and Safety",
  "Rental, Hiring and Real Estate Services",
  "Retail Trade",
  "Transport",
  "Wholesale Trade",
  "Other Services"
]

export const BILLING_TYPE = {
  PER_USER: "per_user",
  PER_LOCATION: "per_location",
  FLAT_RATE: "flat_rate"
}

export const BILLING_TYPE_SUBJECTS = {
  [BILLING_TYPE.PER_USER]: "user",
  [BILLING_TYPE.PER_LOCATION]: "location"
}

export const DEMO_PROFILE = {
  LABELS: "labels"
}

export const DEVICE_PLATFORM_OS = {
  ANDROID: "android",
  IOS: "ios"
}

export const DEVICE_TYPE = {
  UNKNOWN: 0,
  PHONE: 1,
  TABLET: 2,
  DESKTOP: 3,
  TV: 4
}

export const WEB_POSTMESSAGE_TYPE = {
  IMAGES: 0,
  DOWNLOAD: 1,
  TAKE_PHOTOS: 2,
  ROUTE_CHANGED: 3,
  PRINT_LABELS: 4,
  FIND_PRINTERS: 5,
  FIND_PROBES: 6,
  START_READING_PROBE_VALUE: 7,
  STOP_READING_PROBE_VALUE: 8,
  SELECT_PRINTER: 9,
  SCAN_TEXT: 10,
  READ_NFC: 11,
  PONG: 200
}

export const DEVICE_POSTMESSAGE_BEHAVIOUR = {
  COMPLETE_JOB_STEP: "complete_job_step"
}

export const DEVICE_POSTMESSAGE_TYPE = {
  PRINTER_LIST: 1,
  TAKEN_PHOTOS: 2,
  PROBE_LIST: 3,
  PROBE_VALUE: 4,
  PROBE_BUTTON: 5,
  OIL_QUALITY_TESTER_LIST: 8,
  SCANNED_TEXT: 9,
  READ_NFC: 11,
  PING: 200
}

export const IDENTITY_PROVIDER_BEHAVIOUR = {
  NORMAL: "normal",
  AZURE_AD: "azure_ad"
}

export const OPENID_PROMPT = {
  DEFAULT: "default",
  NONE: "none",
  LOGIN: "login",
  CONSENT: "consent",
  SELECT_ACCOUNT: "select_account"
}

export const SENSOR_DIALOG_TYPE = {
  EDIT_SENSOR_NAME: "edit_sensor_name"
}

export const SENSOR_CHANNEL_NAME = {
  TEMPERATURE: "temperature",
  PROBE_TEMPERATURE: "probe_temperature",
  HUMIDITY: "humidity",
  CARBON_DIOXIDE: "carbon_dioxide"
}

export const SENSOR_RULE_TRIGGER_TYPES = {
  ONLINE_OFFLINE: "online_offline",
  BATTERY_HIGH: "battery_high",
  BATTERY_LOW: "battery_low",
  PROBE: "probe",
  HUMIDITY: "humidity",
  SIGNAL: "signal",
  TEMPERATURE: "temperature"
}

export const SENSOR_RULE_TRIGGER_TYPE_CONFIGURATIONS = {
  [SENSOR_RULE_TRIGGER_TYPES.ONLINE_OFFLINE]: {
    label: "Online/Offline",
    unit: "state",
    channel: 0,
    defaultValue: 20,
    operator: "eq",
    validation: {
      min: 20,
      max: 4320,
      type: "minutes",
      errorMessage: "Value must be between 20 and 4320 minutes"
    },
    description: "Alert if the device has not sent within the specified time"
  },
  [SENSOR_RULE_TRIGGER_TYPES.BATTERY_HIGH]: {
    label: "Battery Status (High)",
    unit: "d",
    channel: 112,
    defaultValue: 0,
    operator: "eq",
    description: "Alert if the battery is high"
  },
  [SENSOR_RULE_TRIGGER_TYPES.BATTERY_LOW]: {
    label: "Battery Status (Low)",
    unit: "d",
    channel: 112,
    defaultValue: 1,
    operator: "eq",
    description: "Alert if the battery is low"
  },
  [SENSOR_RULE_TRIGGER_TYPES.PROBE]: {
    label: "Probe Alert",
    unit: "c",
    channel: 7,
    defaultRanges: {
      high: 30,
      low: 10
    },
    defaultNotificationDelay: {
      consecutiveTriggerCount: 1
    },
    description: "Alert when probe temperature is outside the specified range"
  },
  [SENSOR_RULE_TRIGGER_TYPES.HUMIDITY]: {
    label: "Humidity Alert",
    unit: "p",
    channel: 4,
    defaultRanges: {
      high: 90,
      low: 5
    },
    validation: {
      high: { min: 0, max: 100 },
      low: { min: 0, max: 100 },
      errorMessage: "Humidity must be between 0% and 100%"
    },
    defaultNotificationDelay: {
      consecutiveTriggerCount: 1
    },
    description: "Alert when humidity is outside the specified range"
  },
  [SENSOR_RULE_TRIGGER_TYPES.SIGNAL]: {
    label: "Signal Alert",
    unit: "dbm",
    channel: 100,
    defaultRanges: {
      high: 200,
      low: 10
    },
    defaultNotificationDelay: {
      consecutiveTriggerCount: 1
    },
    description: "Alert when signal is outside the specified range"
  },
  [SENSOR_RULE_TRIGGER_TYPES.TEMPERATURE]: {
    label: "Temperature Alert",
    unit: "c",
    channel: 3,
    defaultRanges: {
      high: 30,
      low: 10
    },
    defaultNotificationDelay: {
      consecutiveTriggerCount: 1
    },
    description: "Alert when temperature is outside the specified range"
  }
}

export const SENSOR_RULE_NOTIFICATION_METHOD = {
  EMAIL: "email",
  SMS: "sms"
}

export const SENSOR_RULE_NOTIFICATION_METHOD_LABELS = {
  [SENSOR_RULE_NOTIFICATION_METHOD.EMAIL]: {
    label: "Email",
    valueLabel: "Email"
  },
  [SENSOR_RULE_NOTIFICATION_METHOD.SMS]: {
    label: "SMS",
    valueLabel: "Phone"
  }
}

export const TIMESHEET_STATUS = {
  NOT_SCHEDULED: "not_scheduled",
  SCHEDULED: "scheduled",
  ACTIVE: "active",
  PAUSED: "paused",
  ENDED: "ended"
}

export const TIMER_STATUS = {
  ACTIVE: "active", // running
  PAUSED: "paused",
  USED_UP: "used_up",
  ENDED: "ended" // discarded
}

export const CALENDAR_ENTRY_TYPE = {
  NORMAL: "normal",
  AVAILABLE_UNTIL: "available_until",
  FUTURE: "future"
}

export const TRIGGER_TYPE = {
  SCHEDULE: "schedule",
  EVENT: "event"
}

export const TRIGGER_TARGET_TYPE = {
  NOTIFY_USERS: "notify_users",
  NOTIFY_EMAILS: "notify_emails",
  INTEGRATION: "integration",
  NOTIFY_AUTHOR: "notify_author"
}

export const TRIGGER_TARGET_TYPE_LABELS = {
  [TRIGGER_TARGET_TYPE.NOTIFY_USERS]: "Send a communication to Operandio users",
  [TRIGGER_TARGET_TYPE.NOTIFY_EMAILS]: "Send a communciation to external email address(es)",
  [TRIGGER_TARGET_TYPE.INTEGRATION]: "Raise an integration webhook",
  [TRIGGER_TARGET_TYPE.NOTIFY_AUTHOR]: "Send a communication to the Operandio user that assigned the course"
}

export const TRIGGER_SCHEDULE_SOURCE_OUTPUT_TYPE = {
  MONTHLY_SUMMARY: "monthly_summary",
  WEEKLY_SUMMARY: "weekly_summary",
  YESTERDAY_SUMMARY: "yesterday_summary",
  INTRADAY_SUMMARY: "intraday_summary"
}

export const TRIGGER_SCHEDULE_SOURCE_OUTPUT_TYPE_LABELS = {
  [TRIGGER_SCHEDULE_SOURCE_OUTPUT_TYPE.MONTHLY_SUMMARY]: "Summary of previous calendar months activity",
  [TRIGGER_SCHEDULE_SOURCE_OUTPUT_TYPE.WEEKLY_SUMMARY]: "Summary of the past 7 days of activity",
  [TRIGGER_SCHEDULE_SOURCE_OUTPUT_TYPE.YESTERDAY_SUMMARY]: "Summary of the previous days activity",
  [TRIGGER_SCHEDULE_SOURCE_OUTPUT_TYPE.INTRADAY_SUMMARY]: "Intraday summary of activity"
}

export const TRIGGER_NOTIFY_METHOD = {
  IN_APP: "in_app",
  EMAIL: "email",
  SMS: "sms",
  PUSH: "push"
}

export const TRIGGER_NOTIFY_METHOD_LABELS = {
  [TRIGGER_NOTIFY_METHOD.IN_APP]: "In-application",
  [TRIGGER_NOTIFY_METHOD.EMAIL]: "Email",
  [TRIGGER_NOTIFY_METHOD.SMS]: "SMS",
  [TRIGGER_NOTIFY_METHOD.PUSH]: "Push notification"
}

export const EVENT_NAME = {
  ACTION_CREATED: "action_created",
  ACTION_UPDATED: "action_updated",
  ACTION_OVERDUE: "action_overdue",
  ACTION_COMMENT_CREATED: "action_comment_created",

  USER_TRAINING_COURSE_COMPLETED: "user_training_course_completed",
  USER_TRAINING_MODULE_COMPLETED: "user_training_module_completed",

  JOB_CREATED: "job_created",
  JOB_STEP_COMPLETED: "job_step_completed",
  JOB_SUBMITTED: "job_submitted",
  JOB_OVERDUE: "job_overdue",
  JOB_COMPLETED: "job_completed",

  WORKFLOW_REPORT_CREATED: "workflow_report_created",
  WORKFLOW_REPORT_RENAMED: "workflow_report_renamed",
  WORKFLOW_REPORT_DELETED: "workflow_report_deleted",
  WORKFLOW_REPORT_CANCELLED: "workflow_report_cancelled",
  WORKFLOW_REPORT_LINKED_USERS: "workflow_report_linked_users",
  WORKFLOW_REPORT_LINKED_UPLOADS: "workflow_report_linked_uploads",
  WORKFLOW_REPORT_LINKED_ACTIONS: "workflow_report_linked_actions",
  WORKFLOW_REPORT_LINKED_ASSETS: "workflow_report_linked_assets",
  WORKFLOW_REPORT_LINKED_JOBS: "workflow_report_linked_jobs",
  WORKFLOW_REPORT_LINKED_SUPPLIERS: "workflow_report_linked_suppliers",
  WORKFLOW_REPORT_LINKED_FOODITEMS: "workflow_report_linked_foodItems",
  WORKFLOW_REPORT_DUE_DATE_UPDATED: "workflow_report_due_date_updated",
  WORKFLOW_REPORT_STAGE_COMPLETED: "workflow_report_stage_completed",
  WORKFLOW_REPORT_COMPLETED: "workflow_report_completed",
  WORKFLOW_REPORT_TAGS_UPDATED: "workflow_report_tags_updated",
  WORKFLOW_REPORT_SEVERITY_UPDATED: "workflow_report_severity_updated",
  WORKFLOW_COMMENT_CREATED: "workflow_comment_created"
}

export const EVENT_NAME_LABELS = {
  [EVENT_NAME.ACTION_CREATED]: "Action Created",
  [EVENT_NAME.ACTION_UPDATED]: "Action Updated",
  [EVENT_NAME.ACTION_OVERDUE]: "Action Overdue",
  [EVENT_NAME.ACTION_COMMENT_CREATED]: "Action Comment Created",

  [EVENT_NAME.USER_TRAINING_COURSE_COMPLETED]: "User Training Course Completed",
  [EVENT_NAME.USER_TRAINING_MODULE_COMPLETED]: "User Training Module Completed",

  [EVENT_NAME.JOB_CREATED]: "Job Created",
  [EVENT_NAME.JOB_COMPLETED]: "All Job Steps Completed",
  [EVENT_NAME.JOB_SUBMITTED]: "Job Submitted",
  [EVENT_NAME.JOB_OVERDUE]: "Job Overdue"
}

export const LABEL_TEMPLATE_FIELD_TYPE = {
  NAME: "name",
  USER: "user",
  LOCATION: "location",
  CURRENT_DATETIME: "current_datetime",
  PREP_DATETIME: "prep_datetime",
  READY_DATETIME: "ready_datetime",
  DISCARD_DATETIME: "discard_datetime",
  DYNAMIC_TEXT_ONCREATE: "dynamic_text_oncreate",
  DYNAMIC_TEXT_ONPRINT: "dynamic_text_onprint",
  STATIC_TEXT: "static_text",
  BARCODE: "barcode",
  IMAGE: "image",
  FOOD_ITEM: "food_item"
}

export const BARCODE_TYPE = {
  EAN8: "ean8",
  EAN13: "ean13",
  UPCA: "upca",
  UPCE: "upce",
  CODE128: "code128",
  CODE39: "code39",
  ITF: "interleaved2of5"
}

export const PRINTER_CONNECTION_TYPE = {
  BLUETOOTH: "bluetooth",
  BLUETOOTH_LOW_ENERGY: "bluetooth_low_energy",
  NETWORK: "network",
  USB: "usb"
}

export const PRINTER_CONNECTION_TYPE_LABELS = {
  [PRINTER_CONNECTION_TYPE.BLUETOOTH]: "Bluetooth Classic",
  [PRINTER_CONNECTION_TYPE.BLUETOOTH_LOW_ENERGY]: "Bluetooth Low Energy (LE)",
  [PRINTER_CONNECTION_TYPE.NETWORK]: "Network / Wifi",
  [PRINTER_CONNECTION_TYPE.USB]: "Universal Serial Bus (USB)"
}

export const PRINTER_TYPE = {
  BIXOLON_USB: "bixolon_usb",
  ZEBRA_BLUETOOTH: "zebra_bluetooth",
  ZEBRA_BLUETOOTH_LOW_ENERGY: "zebra_bluetooth_low_energy",
  ZEBRA_NETWORK: "zebra_network",
  ZEBRA_USB: "zebra_usb",
  GAINSCHA_BLUETOOTH: "gainscha_bluetooth",
  GAINSCHA_BLUETOOTH_LOW_ENERGY: "gainscha_bluetooth_low_energy",
  GAINSCHA_NETWORK: "gainscha_network",
  GAINSCHA_USB: "gainscha_usb",
  EPSON_NETWORK: "epson_network",
  UNKNOWN_BLUETOOTH: "unknown_bluetooth",
  UNKNOWN_BLUETOOTH_LOW_ENERGY: "unknown_bluetooth_low_energy",
  UNKNOWN_USB: "unknown_usb",
  UNKNOWN_NETWORK: "unknown_network"
}

export const PRINTER_TYPE_LABELS = {
  [PRINTER_TYPE.BIXOLON_USB]: "Bixolon USB",
  [PRINTER_TYPE.ZEBRA_BLUETOOTH]: "Zebra Bluetooth",
  [PRINTER_TYPE.ZEBRA_BLUETOOTH_LOW_ENERGY]: "Zebra Bluetooth Low Energy",
  [PRINTER_TYPE.ZEBRA_NETWORK]: "Zebra Network",
  [PRINTER_TYPE.ZEBRA_USB]: "Zebra USB",
  [PRINTER_TYPE.GAINSCHA_BLUETOOTH]: "Gainscha Bluetooth",
  [PRINTER_TYPE.GAINSCHA_BLUETOOTH_LOW_ENERGY]: "Gainscha Bluetooth Low Energy",
  [PRINTER_TYPE.GAINSCHA_NETWORK]: "Gainscha Network",
  [PRINTER_TYPE.GAINSCHA_USB]: "Gainscha USB",
  [PRINTER_TYPE.EPSON_NETWORK]: "Epson Network",
  [PRINTER_TYPE.UNKNOWN_BLUETOOTH]: "Generic Bluetooth",
  [PRINTER_TYPE.UNKNOWN_BLUETOOTH_LOW_ENERGY]: "Generic Bluetooth Low Energy",
  [PRINTER_TYPE.UNKNOWN_USB]: "Generic USB",
  [PRINTER_TYPE.UNKNOWN_NETWORK]: "Network"
}

export const PRINTER_USB_VENDOR_ID = {
  [PRINTER_TYPE.ZEBRA_USB]: 2655,
  [PRINTER_TYPE.GAINSCHA_USB]: 1137, // Note this is actually Philips,
  [PRINTER_TYPE.BIXOLON_USB]: 5380
}

export const PRINT_DPI = {
  DPI_203: 203,
  DPI_300: 300,
  DPI_600: 600
}

export const PROBE_TYPE = {
  ETI_BLUETOOTH_LE: "eti_bluetooth_le",
  OIL_QUALITY_TESTER: "oil_quality_tester"
}

export const ROLE_SCOPE = {
  ORGANISATION: "organisation",
  COMMON: "common"
}

export const GROUP_VISIBILITY = {
  GENERAL: "general",
  PRIVATE: "private"
}

export const PROCESS_STEP_LOGIC_RANGE = {
  BETWEEN: "between",
  NOT_BETWEEN: "not_between",
  EQUAL: "equal",
  NOT_EQUAL: "not_equal",
  GREATER_THAN: "greater_than",
  GREATER_OR_EQUAL: "greater_or_equal",
  LESS_THAN: "less_than",
  LESS_OR_EQUAL: "less_or_equal"
}

export const PROCESS_STEP_LOGIC_MULTIPLE_VALUE_RANGES = [
  PROCESS_STEP_LOGIC_RANGE.BETWEEN,
  PROCESS_STEP_LOGIC_RANGE.NOT_BETWEEN
]

export const PROCESS_STEP_LOGIC_OUTCOME = {
  ACTION: "action",
  NOTE: "note",
  NOTE_TEXT: "note_text",
  NOTE_IMAGE: "note_image",
  NOTE_FILE: "note_file",
  SHOW_STEPS: "show_steps"
}

export const PROCESS_STEP_LOGIC_VALUE_TYPE_CONFIGURATIONS = {
  number: {
    ranges: [
      PROCESS_STEP_LOGIC_RANGE.BETWEEN,
      PROCESS_STEP_LOGIC_RANGE.NOT_BETWEEN,
      PROCESS_STEP_LOGIC_RANGE.EQUAL,
      PROCESS_STEP_LOGIC_RANGE.NOT_EQUAL,
      PROCESS_STEP_LOGIC_RANGE.GREATER_THAN,
      PROCESS_STEP_LOGIC_RANGE.GREATER_OR_EQUAL,
      PROCESS_STEP_LOGIC_RANGE.LESS_THAN,
      PROCESS_STEP_LOGIC_RANGE.LESS_OR_EQUAL
    ],
    outcomes: [...Object.values(PROCESS_STEP_LOGIC_OUTCOME)]
  },
  text: {
    ranges: [PROCESS_STEP_LOGIC_RANGE.EQUAL, PROCESS_STEP_LOGIC_RANGE.NOT_EQUAL],
    outcomes: [...Object.values(PROCESS_STEP_LOGIC_OUTCOME)]
  }
}

export const PROCESS_STEP_LOGIC_OUTCOME_LABELS = {
  [PROCESS_STEP_LOGIC_OUTCOME.ACTION]: "Require an action",
  [PROCESS_STEP_LOGIC_OUTCOME.NOTE]: "Require a note",
  [PROCESS_STEP_LOGIC_OUTCOME.NOTE_TEXT]: "Require a text note",
  [PROCESS_STEP_LOGIC_OUTCOME.NOTE_IMAGE]: "Require an image note",
  [PROCESS_STEP_LOGIC_OUTCOME.NOTE_FILE]: "Require a file note",
  [PROCESS_STEP_LOGIC_OUTCOME.SHOW_STEPS]: "Show step"
}

export const PROCESS_STEP_FORMAT_UNIT = {
  NUMERIC_PERCENTAGE: "numeric_percentage",
  TEMPERATURE_CELSIUS: "temperature_celsius",
  TEMPERATURE_FAHRENHEIT: "temperature_fahrenheit",
  WEIGHT_GRAMS: "weight_grams",
  WEIGHT_KILOGRAMS: "weight_kilograms",
  WEIGHT_OUNCES: "weight_ounces",
  WEIGHT_POUNDS: "weight_pounds",
  LENGTH_MILLIMETERS: "length_millimeters",
  LENGTH_CENTIMETERS: "length_centimeters",
  LENGTH_METERS: "length_meters",
  LENGTH_KILOMETERS: "length_kilometers",
  LENGTH_INCHES: "length_inches",
  LENGTH_FEET: "length_feet",
  LENGTH_YARDS: "length_yards",
  LENGTH_MILES: "length_miles",
  VOLUME_MILLILITERS: "volume_milliliters",
  VOLUME_LITERS: "volume_liters",
  VOLUME_CUBIC_CENTIMETERS: "volume_cubic_centimeters",
  VOLUME_CUBIC_METERS: "volume_cubic_meters",
  VOLUME_FLUID_OUNCES: "volume_fluid_ounces",
  VOLUME_GALLONS: "volume_gallons",
  VOLUME_CUBIC_INCHES: "volume_cubic_inches",
  VOLUME_CUBIC_FEET: "volume_cubic_feet",
  TIME_SECONDS: "time_seconds",
  TIME_MINUTES: "time_minutes",
  TIME_HOURS: "time_hours",
  TIME_DAYS: "time_days",
  CURRENCY_DOLLAR: "currency_dollar",
  CURRENCY_POUND: "currency_pound",
  CURRENCY_EURO: "currency_euro",
  CURRENCY_DIRHAM: "currency_dirham",
  ACIDITY_PH: "acidity_ph",
  OIL_QUALITY_TPM: "oil_quality_tpm"
}

export const PROCESS_STEP_SELECTION_SOURCES = {
  USERS: "users",
  SUPPLIERS: "suppliers",
  ASSETS: "assets",
  FOOD_ITEMS: "foodItems",
  CUSTOM_ITEMS: "custom_items"
}
export const PROCESS_STEP_SELECTION_SOURCE_LABELS = {
  [PROCESS_STEP_SELECTION_SOURCES.USERS]: "Users",
  [PROCESS_STEP_SELECTION_SOURCES.SUPPLIERS]: "Suppliers",
  [PROCESS_STEP_SELECTION_SOURCES.ASSETS]: "Assets",
  [PROCESS_STEP_SELECTION_SOURCES.FOOD_ITEMS]: "Food items",
  [PROCESS_STEP_SELECTION_SOURCES.CUSTOM_ITEMS]: "Custom items"
}

export const DUE_AT = {
  ALL: "all",
  NO_DATE: "no_date",
  ANY_DATE: "any_date",
  OVERDUE: "overdue"
}

export const DUE_AT_LABELS = {
  [DUE_AT.ALL]: "Any",
  [DUE_AT.NO_DATE]: "No due date",
  [DUE_AT.ANY_DATE]: "Any due date",
  [DUE_AT.OVERDUE]: "Overdue"
}

export const ACTION_PRIORITY = {
  CRITICAL: "critical",
  HIGH: "high",
  NORMAL: "normal",
  LOW: "low"
}

export const ACTION_PRIORITY_LABELS = {
  [ACTION_PRIORITY.CRITICAL]: "Critical",
  [ACTION_PRIORITY.LOW]: "Low",
  [ACTION_PRIORITY.NORMAL]: "Normal",
  [ACTION_PRIORITY.HIGH]: "High"
}

export const ACTION_STATUS = {
  UNRESOLVED: "unresolved",
  DEFERRED: "deferred",
  IN_PROGRESS: "in_progress",
  BLOCKED: "blocked",
  RESOLVED: "resolved",
  CANCELLED: "cancelled"
}

export const ACTION_STATUS_LABELS = {
  [ACTION_STATUS.UNRESOLVED]: "Unresolved",
  [ACTION_STATUS.IN_PROGRESS]: "In progress",
  [ACTION_STATUS.BLOCKED]: "Blocked",
  [ACTION_STATUS.RESOLVED]: "Resolved",
  [ACTION_STATUS.CANCELLED]: "Cancelled",
  [ACTION_STATUS.DEFERRED]: "Deferred"
}

export const ACTION_STATUS_VERBS = {
  [ACTION_STATUS.UNRESOLVED]: "Unresolve",
  [ACTION_STATUS.IN_PROGRESS]: "In progress",
  [ACTION_STATUS.BLOCKED]: "Block",
  [ACTION_STATUS.RESOLVED]: "Resolve",
  [ACTION_STATUS.CANCELLED]: "Cancel",
  [ACTION_STATUS.DEFERRED]: "Defer"
}

export const HAS_ASSETS = {
  ALL: "all",
  WITH_ASSET: "with_asset",
  WITHOUT_ASSET: "without_asset"
}

export const HAS_ASSETS_LABELS = {
  [HAS_ASSETS.ALL]: "Any",
  [HAS_ASSETS.WITH_ASSET]: "With asset",
  [HAS_ASSETS.WITHOUT_ASSET]: "Without asset"
}

export const COURSE_STATUS = {
  ACTIVE: "active",
  INACTIVE: "inactive"
}

export const COURSE_STATUS_LABELS = {
  [COURSE_STATUS.ACTIVE]: "Active",
  [COURSE_STATUS.INACTIVE]: "Inactive"
}

export const TEMPERATURE_TIMER_STATUS = {
  IN_RANGE: "in_range",
  OUT_OF_RANGE: "out_of_range"
}

export const TEMPERATURE_TIMER_STATUS_LABELS = {
  [TEMPERATURE_TIMER_STATUS.IN_RANGE]: "In range",
  [TEMPERATURE_TIMER_STATUS.OUT_OF_RANGE]: "Out of range"
}

export const JOB_COMPLETION_STATUS = {
  COMPLETED_ON_TIME: "completed_on_time",
  COMPLETED_LATE: "completed_late",
  IN_PROGRESS: "in_progress",
  OVERDUE: "overdue",
  UNCOMPLETED: "uncompleted"
}

export const JOB_COMPLETION_STATUS_LABELS = {
  [JOB_COMPLETION_STATUS.COMPLETED_ON_TIME]: "Completed (On time)",
  [JOB_COMPLETION_STATUS.COMPLETED_LATE]: "Completed (Late)",
  [JOB_COMPLETION_STATUS.IN_PROGRESS]: "In Progress",
  [JOB_COMPLETION_STATUS.OVERDUE]: "Overdue",
  [JOB_COMPLETION_STATUS.UNCOMPLETED]: "Uncompleted"
}

export const PREP_ITEM_ROUNDING = {
  NONE: "none",
  UP: "up",
  DOWN: "down"
}

export const SUPPLIER_TYPE = {
  UNCLASSIFIED: "unclassified",
  GOODS: "goods",
  SERVICES: "services"
}

export const SUPPLIER_TYPE_LABELS = {
  [SUPPLIER_TYPE.UNCLASSIFIED]: "",
  [SUPPLIER_TYPE.GOODS]: "Goods",
  [SUPPLIER_TYPE.SERVICES]: "Services"
}

export const SUPPLIER_STATUS = {
  ACTIVE: "active",
  INACTIVE: "inactive"
}

export const SUPPLIER_STATUS_LABELS = {
  [SUPPLIER_STATUS.ACTIVE]: "Active",
  [SUPPLIER_STATUS.INACTIVE]: "Inactive"
}

export const DOWNLOAD_STATUS = {
  IN_PROGRESS: "in_progress",
  COMPLETED: "completed",
  FAILED: "failed"
}

export const TRAINING_COURSE_TAB = {
  BUILDER: "builder",
  OPTIONS: "options"
}

export const USER_TRAINING_COURSE_TAB = {
  MODULES: "modules",
  FEEDBACK: "feedback"
}

export const TRAINING_CREATOR_TYPE = {
  COURSE: "courses",
  MODULE: "modules",
  OBSERVATION: "observations"
}

export const TRAINING_TYPE = {
  TRAINING: "training",
  OBSERVATION: "observation"
}

export const TRAINING_MODULE_STEP_TYPE = {
  // Content
  VIDEO_URL: "video_url",
  VIDEO_UPLOAD: "video_upload",
  CONTENT: "content",
  SCORM_UPLOAD: "scorm_upload",

  // Questions
  SELECT: "select",
  MULTIPLE_CHOICE: "multiple_choice",
  TRUE_FALSE: "true_false",
  ORDERING: "ordering",
  TEXT_RESPONSE: "text_response",
  MATCH_UP: "match_up",

  // Observations
  TEXT_ENTRY: "text_entry",
  CHECKLIST: "checklist",
  SINGLE_CHOICE: "single_choice"
}

export const TRAINING_MODULE_NON_RESPONSE_STEP_TYPES = [
  TRAINING_MODULE_STEP_TYPE.VIDEO_URL,
  TRAINING_MODULE_STEP_TYPE.VIDEO_UPLOAD,
  TRAINING_MODULE_STEP_TYPE.SCORM_UPLOAD,
  TRAINING_MODULE_STEP_TYPE.CONTENT
]

export const TRAINING_PREVIEW_TYPE = {
  COURSE: "course",
  MODULE: "module"
}

export const TRAINING_COURSE_ASSIGNMENT_TYPE = {
  MANUAL: "manual",
  AUTO: "auto"
}

export const TRAINING_ASSIGNMENT_TIME_UNITS = {
  DAYS: "days",
  WEEKS: "weeks",
  MONTHS: "months",
  YEARS: "years"
}

export const VIDEO_TYPES = {
  URL: "url",
  UPLOAD: "upload"
}

export const OBSERVATION_ASSESSMENT_STEP_ID = {
  NOTES: "6f62736e6f74657371756573",
  RATING: "6f6273726174657175657374"
}

export const MENTION_TYPE = {
  KNOWLEDGE: "knowledge"
}

export const INTEGRATION_PROVIDER_RECONNECT_STRATEGY = {
  NO_RECONNECT: "no_reconnect",
  STATE: "state",
  REDIRECT_URI: "redirect_uri"
}

export const WORKFLOW_STATUS = {
  SUBMITTED: "submitted",
  OPEN: "open",
  CANCELLED: "cancelled",
  DRAFT: "draft"
}

export const SEVERITY = {
  Low: "low",
  Normal: "normal",
  High: "high",
  Critical: "critical"
}
